import { render, staticRenderFns } from "./ViewVacationSubmitted.vue?vue&type=template&id=a87bff90&scoped=true"
import script from "./ViewVacationSubmitted.vue?vue&type=script&lang=ts"
export * from "./ViewVacationSubmitted.vue?vue&type=script&lang=ts"
import style0 from "./ViewVacationSubmitted.vue?vue&type=style&index=0&id=a87bff90&prod&lang=css"
import style1 from "./ViewVacationSubmitted.vue?vue&type=style&index=1&id=a87bff90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87bff90",
  null
  
)

export default component.exports